module.exports = __webpack_public_path__ + "img/3.7da54e64.png";